var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distribution-map"},[_c('div',{staticClass:"dismap-container"},[_c('div',{ref:"dismapchart",staticClass:"dismap"})])])}
var staticRenderFns = []

export { render, staticRenderFns }